import React from "react"
import "../css/Loader.scss";
export default function renderLoader(cName){
    let classes = 'fa fa-sync fa-spin ' + (cName || ''); //spin
    return (
        <div>
            <i className={classes} />
        </div>
    );
};